import React from 'react';
import { QueryBuilder, add } from 'react-querybuilder';
import type { Field, RuleGroupType } from 'react-querybuilder';
import { Box, Button } from '@mantine/core';
import { IconPlus, IconRadiusBottomLeft } from '@tabler/icons';
import 'react-querybuilder/dist/query-builder.css';
import { MantineQueryBuilderComponents } from './components/index';

interface CustomQueryBuilderProps {
  fields: Field[];
  query: RuleGroupType;
  onQueryChange: (query: RuleGroupType) => void;
  addRuleToNewGroups?: boolean;
  autoSelectField?: boolean;
  autoSelectOperator?: boolean;
  showCombinatorsBetweenRules?: boolean;
  showNotToggle?: boolean;
  showCloneButtons?: boolean;
  resetOnFieldChange?: boolean;
  resetOnOperatorChange?: boolean;
}

// Component that renders nothing
const NullComponent = () => null;

export const CustomQueryBuilder: React.FC<CustomQueryBuilderProps> = ({
  fields,
  query,
  onQueryChange,
  ...props
}) => {
  // Handler for adding a new rule
  const handleAddRule = () => {
    const newQuery = add(query, { field: fields[0]?.name || '', operator: '=', value: '' }, []);
    onQueryChange(newQuery);
  };

  return (
    <Box
      sx={{
        // Custom rule group styling
        '.ruleGroup': {
          backgroundColor: 'transparent',
          border: 'none',
          padding: '0px',
        },
        '.ruleGroup .rule': {
          gap: 0,
        },
        '.queryBuilder-branches .rule::before, .queryBuilder-branches .rule::after, .queryBuilder-branches .ruleGroup .ruleGroup::before, .queryBuilder-branches .ruleGroup .ruleGroup::after': {
          borderColor: '#4c6ef5',
        }
      }}
    >
      <QueryBuilder<RuleGroupType>
        fields={fields}
        query={query}
        onQueryChange={onQueryChange}
        controlElements={MantineQueryBuilderComponents}
        controlClassnames={{ queryBuilder: 'queryBuilder-branches' }}
        {...props}
      />
      
      {/* Custom Add Rule button at the bottom */}
      <Box mt="xs">
        <Button
          variant="light"
          color="indigo"
          size="xs"
          h={24}
          leftIcon={<IconRadiusBottomLeft size={14} />}
          rightIcon={<IconPlus size={14} />}
          onClick={handleAddRule}
        >
          Add New Rule
        </Button>
      </Box>
    </Box>
  );
}; 